import breakpoints from "./breakpoints";

const mediaQueries = {
  xSmall: `@media only screen and (max-width: ${breakpoints.sm - 0.01})`,
  smallDown: `@media only screen and (max-width: ${breakpoints.md - 0.01})`,
  small: `@media only screen and (min-width: ${breakpoints.sm}) and (max-width: ${breakpoints.md - 0.01})`,
  smallUp: `@media only screen and (min-width: ${breakpoints.sm})`,
  mediumDown: `@media only screen and (max-width: ${breakpoints.lg - 0.01})`,
  medium: `@media only screen and (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg - 0.01})`,
  mediumUp: `@media only screen and (min-width: ${breakpoints.md})`,
  largeDown: `@media only screen and (max-width: ${breakpoints.xl - 0.01})`,
  large: `@media only screen and (min-width: ${breakpoints.lg}) and (max-width: ${breakpoints.xl - 0.01})`,
  largeUp: `@media only screen and (min-width: ${breakpoints.lg})`,
  xLargeDown: `@media only screen and (max-width: ${breakpoints.xxl - 0.01})`,
  xLarge: `@media only screen and (min-width: ${breakpoints.xl}) and (max-width: ${breakpoints.xxl - 0.01})`,
  xLargeUp: `@media only screen and (min-width: ${breakpoints.xl})`,
  xxLarge: `@media only screen and (min-width: ${breakpoints.xxl})`,
};

export default mediaQueries;
